export const TabsData = {
  business_listings: [
    "All Listings",
    "New Listings",
    "In Review Listings",
    "Published Listings",
    "Declined Listings",
    "Featured Listings",
  ],
  vouchers: [
    "Vouchers Dashboard",
    "Manage Vouchers",
    "Featured Vouchers",
    "Transactions",
  ],
  coupons: ["Coupons Dashboard", "Manage Coupons", "Featured Coupons", "My Coupons","Bussiness Listing"],
  DashboardTable: ["Top Categories", "All Categories"],
  comunications: ["Manage Templates", "Bulk Notify"],
  marketplace_setup: [
    "Home Page Setup",
    "Pages",
    "Categories",
    "Privacy Policy",
    "Terms & Conditions",
    "Profile",
  ],
  user_administration: ["Manage Users", "Login History"],
  customer_listings: ["All Listings",],
  events_listings: [
    "All Events",
    "New Events",
    "In Review Events",
    "Published Events",
    "Declined Events",
  ],

};
